import apiService from "../../services/api-service";

export function resetPassword(requestBody) {
    apiService.resetPassword(requestBody).then(response => {
        console.log("resposne from reset password::", response);
        let responseFromServer = response && response.data;
        alert(responseFromServer.message);
        if (!responseFromServer.error) {
            window.location.href = "https://blueskymeet.com/";
        }
    }, error => {
        console.log("error::", error)
    })
}